import {Component, Input, OnInit, Optional} from '@angular/core';
import {Questionnaire} from '@ngmedax/common-questionnaire-types';
import {TRANSLATION_EDITOR_SCOPE} from '../../../../constants';
import {KEYS} from '../../../../translation-keys';
import {Translatable, TranslationService} from '@ngmedax/translation';


// hack to inject decorator declarations. must occur before class declaration!
export interface QuestionTypeSignatureComponent extends Translatable {}

@Component({
  selector: 'app-qa-question-signature',
  templateUrl: './question-type-signature.component.html',
  styleUrls: ['./question-type-signature.component.css', '../../../shared/reusable.css']
})
@Translatable({scope: TRANSLATION_EDITOR_SCOPE, keys: KEYS})
export class QuestionTypeSignatureComponent implements OnInit {
  @Input() question: Questionnaire.Container;

  public ngOnInit() {
    if (!this.question.options) {
      this.question.options = {};
    }
    if (typeof this.question.options.autoUnlock === 'undefined') {
      this.question.options.autoUnlock = false;
    }
  }
}
